<app-page-body [class]="'tw-pt-2'" *ngIf="!isVisibleHelpPage">
  <!-- header -->
  <app-page-header
    custom-header
    [title]="'pages.sendSmartSMS.title' | translate"
    [loading]="loading"
    [showAddBtn]="false"
    [showAuditBtn]="false"
    (onShowHelp)="onShowHelpPage()"
  >
    <div class="card-toolbar" after-btns>
      <!-- open smartSmsRequestConfirmData -->
      <button
        *ngIf="!formPageConfig?.isEditMode"
        type="button"
        class="btn txt-lg button-shadow tw-mx-1 tw-flex-center btn-hover-rise"
        [themeColor]="'btn-light'"
        mat-ripple
        (click)="openPage('smartSend')"
      >
        <span class="tw-mx-1">{{ "common.requestsList" | translate }}</span>
      </button>
    </div>
  </app-page-header>

  <div class="app-page-content">
    <form [formGroup]="form" autocomplete="off">
      <div class="row panels-row">
        <section
          class="tw-h-full xl:tw-w-1/3"
          [class]="!showSidePanel ? 'order-1' : ''"
        >
          <!-- <div class="tw-flex"> -->
          <div class="row">
            <!-- first column -->
            <div class="smart-sms">
              <fieldset class="tw-h-full smart-sms-column">
                <legend class="tw-flex-center">
                  {{ pageVocabs + "legends.publicProperties" | translate }}
                </legend>

                <app-filter-row
                  [filterItems]="filterItems"
                  [smartRequestType]="smartRequestType"
                ></app-filter-row>

                <!--request type-->
                <div class="sm:tw-w-1/2 md:tw-w-full tw-mt-5">
                  <enum-select-search
                    class="tw-w-full"
                    enumName="SmartRequestTypes"
                    [control]="form?.get('smartRequestType')"
                    [label]="pageVocabs + 'smartRequestType'"
                    [(value)]="smartRequestType"
                    (valueChange)="changeSmartRequestType($event)"
                    (onError)="onClose()"
                  >
                  </enum-select-search>
                </div>

                <!-- request name * requiered item -->
                <div class="tw-w-full">
                  <form-field
                    [(value)]="title"
                    [control]="form?.get('title')"
                    [label]="pageVocabs + 'requestName' | translate"
                  >
                  </form-field>
                </div>

                <!-- date time filter selector * required item  -->
                <app-periodic-date-time-picker
                  [config]="periodicDateTimeConfig"
                  (startDateTime)="startTime = $event"
                  *ngIf="getIsPeriodic() == false"
                  (endDateTime)="endTime = $event"
                >
                </app-periodic-date-time-picker>

                <!-- periodic type-->
                <div class="tw-w-full tw-mt-3 tw-mb-5">
                  <div class="tw-flex tw-justify-between tw-items-center">
                    <div class="checkbox-section">
                      <mat-slide-toggle
                        formControlName="isPeriodic"
                        [color]="'accent'"
                      >
                        {{ pageVocabs + "periodicSmartSms" | translate }}
                      </mat-slide-toggle>
                    </div>
                  </div>
                </div>

                <!--manual and reverse polygon-->
                <app-manual-polygon
                  [pageVocabs]="pageVocabs"
                  [isShowMap]="isShowMap"
                  [form]="form"
                  (finalPolygon)="polygon = $event"
                  (removePolygon)="removePolygon = $event"
                ></app-manual-polygon>

                <!--cell list-->
                <div *ngIf="isShowCellList" class="sm:tw-w-1/2 md:tw-w-full">
                  <form-textarea
                    class="tw-w-full"
                    [label]="pageVocabs + 'cellList'"
                    [(value)]="cellList"
                    [control]="form?.get('cellList')"
                    [rows]="5"
                    [placeholder]="cellListSample"
                  >
                  </form-textarea>
                </div>

                <!--grayListExpireHour-->
                <div *ngIf="isShowGrayListExpireHour" class="tw-w-full tw-mt-3">
                  <p class="tw-mr-2 tw-text-gray-700">
                    {{ pageVocabs + "grayListExpireHour" | translate }}
                  </p>
                  <form-field
                    type="tel"
                    [hasNumberSeparator]="true"
                    [control]="form?.get('grayListExpireHour')"
                    [(value)]="grayListExpireHour"
                    [label]="pageVocabs + 'timingOfRepetitions' | translate"
                  >
                  </form-field>
                </div>

                <!-- gray list -->
                <smart-sms-campaigns-select-search
                  *ngIf="isShowCampaigns"
                  class="tw-w-full"
                  label="common.grayList"
                  [control]="form?.get('campaignId')"
                  [(value)]="campaignId"
                  [isShowRefreshBtn]="true"
                  (onError)="onClose()"
                >
                </smart-sms-campaigns-select-search>

                <!-- cell list btn -->
                <button
                  *ngIf="isShowCellList"
                  type="button"
                  (click)="getCellsList()"
                  mat-ripple
                  class="btn btn-light-primary tw-mt-3 button-shadow btn-hover-rise"
                  [themeColor]="'btn'"
                >
                  <ng-container>
                    <span>{{ "common.cellsByName" | translate }}</span>
                  </ng-container>
                </button>

                <!-- clubId -->
                <smart-sms-clubs-select-search
                  *ngIf="isShowClub"
                  class="tw-w-full"
                  [control]="form?.get('clubId')"
                  [label]="pageVocabs + 'club'"
                  [value]="clubId"
                  [isShowRefreshBtn]="true"
                  (valueChange)="clubId = $event"
                  (onError)="onClose()"
                >
                </smart-sms-clubs-select-search>

                <!-- province-->
                <province-select-search
                  *ngIf="isShowProvince"
                  class="tw-w-full"
                  [control]="form?.get('province')"
                  [(value)]="provinceId"
                  (onError)="onClose()"
                >
                </province-select-search>

                <!-- cities -->
                <cities-chip-list-select-search
                  *ngIf="isShowCities"
                  [id]="provinceId"
                  [isShowSelectAll]="true"
                  [control]="form?.get('cities')"
                  (valuesChange)="cities = $event"
                  (onError)="onClose()"
                >
                </cities-chip-list-select-search>

                <!-- provinces -->
                <provinces-chip-list-select-search
                  *ngIf="isShowProvinces"
                  [isShowSelectAll]="true"
                  [control]="form?.get('provinces')"
                  (valuesChange)="provinces = $event"
                  (onError)="onClose()"
                >
                </provinces-chip-list-select-search>

                <!-- targetAirportId-->
                <airports-select-search
                  *ngIf="isShowTargetAirport"
                  class="tw-w-full"
                  [control]="form?.get('targetAirportId')"
                  [(value)]="targetAirportId"
                  (onError)="onClose()"
                >
                </airports-select-search>

                <!-- operationType -->
                <enum-select-search
                  *ngIf="isShowClub"
                  class="tw-w-full"
                  enumName="SmartSmsClubOperationType"
                  [label]="pageVocabs + 'operationType'"
                  [control]="form?.get('operationType')"
                  [(value)]="operationType"
                  (onError)="onClose()"
                >
                </enum-select-search>

                <!---------------------------------------------------- Optional Filters ---------------------------------------------------->

                <!-- age filter item -->
                <div class="tw-w-full" *ngIf="getMostShowFilterRow('age')">
                  <form-field-age-range
                    [form]="form"
                    [controlName]="'ageRange'"
                    [startRangeControlName]="'startRangeControlName'"
                    [endRangeControlName]="'endRangeControlName'"
                    (value)="selectedAgeRangeChange($event)"
                    [maxlabel]="pageVocabs + 'ageTo' | translate"
                    [minlabel]="pageVocabs + 'ageFrom' | translate"
                  >
                  </form-field-age-range>
                </div>

                <!-- mobile prefix -->
                <div
                  class="tw-w-full"
                  *ngIf="getMostShowFilterRow('mobilePrefix')"
                >
                  <form-field
                    class="tw-w-full mobile-prefix-container"
                    [label]="pageVocabs + 'mobilePrefix'"
                    [maxLength]="6"
                    [control]="form?.get('mobilePrefix')"
                    [isLtr]="true"
                    textAlign="left"
                    fontSize="15px"
                    [(value)]="numberPrefix"
                  >
                    <b
                      suffix-content
                      class="tw-text-xl tw-text-gray-700 dark:tw-text-gray-400 tw-relative tw-top-0.5"
                      >98</b
                    > </form-field
                  ><!-- end of prefix to apply in query -->
                </div>

                <!-- gender filter item -->
                <div class="tw-w-full" *ngIf="getMostShowFilterRow('gender')">
                  <enum-select-search
                    class="tw-w-full"
                    enumName="EnumSmartAdsGender"
                    label="common.gender"
                    [control]="form?.get('gender')"
                    [(value)]="gender"
                    (onError)="onClose()"
                  >
                  </enum-select-search>
                </div>

                <!-- device type filter item-->
                <div
                  class="tw-w-full"
                  *ngIf="getMostShowFilterRow('DeviceType')"
                >
                  <device-types-chip-list-select-search
                    [label]="pageVocabs + 'deviceTypes'"
                    [control]="form?.get('deviceType')"
                    (valuesChange)="selectedDeviceTypesChange($event)"
                    (onError)="onClose()"
                  >
                  </device-types-chip-list-select-search>
                </div>

                <!-- device brand filter item-->
                <div
                  class="tw-w-full"
                  *ngIf="getMostShowFilterRow('DeviceBrand')"
                >
                  <!-- <brand-select-search
                    [label]="pageVocabs + 'deviceBrands'"
                    [control]="form?.get('deviceBrand')"
                    (itemChange)="selectedDeviceBrandChange($event)"
                    (onError)="onClose()"
                  >
                  </brand-select-search> -->

                  <brands-chip-list-select-search
                    [label]="pageVocabs + 'deviceBrands'"
                    [control]="form?.get('deviceBrand')"
                    (itemsChange)="selectedDeviceBrandChange($event)"
                    (onError)="onClose()"
                  >
                  </brands-chip-list-select-search>

                  <div
                    *ngIf="isShowBrandModel"
                    class="md:tw-w-full tw-mt-2 rtl:tw-ml-[-59px] ltr:tw-mr-[-59px]"
                  >
                    <div class="alert alert-warning border tw-text-center">
                      <p class="tw-font-medium">
                        {{ "messages.searchInModels" | translate }}
                      </p>
                    </div>
                  </div>
                  <brand-models-api-chip-list-select-search
                    *ngIf="isShowBrandModel"
                    [isUseApiFilter]="true"
                    [optimalSearch]="true"
                    [hasInfiniteScroll]="true"
                    [brandName]="selectedDeviceBrandName"
                    [isShowDeleteBtn]="false"
                    [filteredValue]="filteredValue"
                    [label]="pageVocabs + 'deviceModels'"
                    [control]="form?.get('deviceModel')"
                    [values]="selectedDeviceModels"
                    (itemsChange)="selectedDeviceModelChange($event)"
                    (filteredItem)="filteredValue = $event"
                    (onError)="onClose()"
                  >
                  </brand-models-api-chip-list-select-search>
                  <fieldset *ngIf="isShowBrandModel">
                    <legend
                      class="tw-mt-4 border border-priamry bg-gradient-black !tw-text-[0.97rem]"
                    >
                      {{ pageVocabs + "deviceModels" | translate }}
                    </legend>
                    <div
                      class="tw-h-[160px] tw-overflow-y-scroll tw-overflow-x-hidden"
                    >
                      <div
                        class="row tw-min-h-[55px] tw-p-[2px]"
                        *ngIf="selectedDeviceModels.length > 0"
                      >
                        <div
                          class="sm:tw-w-1/2 tw-mt-1"
                          *ngFor="let item of selectedDeviceModels"
                        >
                          <div
                            class="tw-flex tw-py-[7px] tw-px-[9px] tw-h-[48px] tw-rounded tw-bg-slate-100 tw-border tw-border-gray-300 tw-cursor-pointer"
                          >
                            <span
                              class="mdi mdi-trash-can-outline text-danger tw-ml-2 fs-4"
                              (click)="onRemoveDeviceModel(item.id)"
                            ></span>
                            <span
                              class="tw-flex tw-items-center tw-overflow-auto"
                              >{{ item.name }}</span
                            >
                          </div>
                        </div>
                      </div>
                      <!-- empty -->
                      <ng-container *ngIf="selectedDeviceModels.length == 0">
                        <div
                          class="tw-flex tw-justify-center tw-text-lg text-gray tw-font-medium tw-items-center"
                        >
                          {{ "common.empty" | translate }}
                        </div>
                      </ng-container>
                    </div>
                  </fieldset>
                </div>

                <!-- اقامت گاه شبانه و روزانه-->
                <div
                  class="tw-w-full"
                  *ngIf="getMostShowFilterRow('Eghamatgah')"
                >
                  <!-- <div class="disabled-filter">
                    <h5>
                      {{'pages.createSmartSmsRequest.filters.eghamatgah' | translate}}
                    </h5>
                    <div>
                      {{pageVocabs+'filters.notImplemented' | translate}}
                    </div>
                  </div> -->
                  <enum-select-search
                    class="tw-w-full"
                    enumName="SmartSmsRequestResidenceState"
                    label="{{ pageVocabs }}residenceState"
                    [control]="form?.get('residenceState')"
                    [(value)]="residenceState"
                    (onError)="onClose()"
                  >
                  </enum-select-search>
                  <enum-select-search
                    class="tw-w-full"
                    enumName="SmartSmsRequestJoberState"
                    label="{{ pageVocabs }}joberState"
                    [control]="form?.get('joberState')"
                    [(value)]="joberState"
                    (onError)="onClose()"
                  >
                  </enum-select-search>
                </div>

                <!-- پروفایل گردشگری-->
                <div class="tw-w-full" *ngIf="getMostShowFilterRow('Vacaton')">
                  <!-- <div class="disabled-filter">
                    <h5>
                      {{'pages.createSmartSmsRequest.filters.gardeshgari' | translate}}
                    </h5>
                    <div>
                      {{pageVocabs+'filters.notImplemented' | translate}}
                    </div>
                  </div> -->
                  <enum-select-search
                    class="tw-w-full"
                    enumName="SmartSmsRequestTravellerState"
                    label="{{ pageVocabs }}travellerState"
                    [control]="form?.get('travellerState')"
                    [(value)]="travellerState"
                    (onError)="onClose()"
                  >
                  </enum-select-search>
                  <div
                    class="tw-w-full"
                    *ngIf="
                      travellerState == 1 && getMostShowFilterRow('Vacaton')
                    "
                  >
                    <!-- provinces -->
                    <provinces-chip-list-select-search
                      [label]="pageVocabs + 'travellerProvinces'"
                      [control]="form?.get('travellerProvinces')"
                      (valuesChange)="selectedTravellerProvincesChange($event)"
                      (onError)="onClose()"
                    >
                    </provinces-chip-list-select-search>
                  </div>
                </div>

                <!-- پروفایل بانکی -->
                <div
                  class="tw-w-full"
                  *ngIf="getMostShowFilterRow('BankingProfile')"
                >
                  <div class="disabled-filter">
                    <h5>
                      {{
                        "pages.createSmartSmsRequest.filters.bankProfile"
                          | translate
                      }}
                    </h5>
                    <div>
                      {{ pageVocabs + "filters.notImplemented" | translate }}
                    </div>
                  </div>
                </div>

                <!-- پروفایل مشاغل -->
                <div class="tw-w-full" *ngIf="getMostShowFilterRow('Jobs')">
                  <div class="tw-w-full">
                    <mat-label>{{
                      "pages.createSmartSmsRequest.filters.jobs" | translate
                    }}</mat-label>
                    <artistic-culture-selection-list
                      searchLabel="common.search"
                      (values)="artisticCulture = $event"
                      [values]="artisticCulture"
                      responsiveClass="md:tw-w-1/2"
                      searchBoxGridclass="tw-w-full"
                      [isSmallSize]="true"
                    >
                    </artistic-culture-selection-list>
                  </div>
                  <!-- <div class="disabled-filter">
                    <h5>
                      {{'pages.createSmartSmsRequest.filters.jobs' | translate}}
                    </h5>
                    <div>
                      {{pageVocabs+'filters.notImplemented' | translate}}
                    </div>
                  </div> -->
                </div>

                <!-- پروفایل علاقه مندیها-->
                <div
                  class="tw-w-full"
                  *ngIf="getMostShowFilterRow('Favorites')"
                >
                  <div class="disabled-filter">
                    <h5>
                      {{
                        "pages.createSmartSmsRequest.filters.favorites"
                          | translate
                      }}
                    </h5>
                    <div>
                      {{ pageVocabs + "filters.notImplemented" | translate }}
                    </div>
                  </div>
                </div>

                <!-- پروفایل ارتباطات-->
                <div
                  class="tw-w-full"
                  *ngIf="getMostShowFilterRow('ComminucationProfile')"
                >
                  <div class="disabled-filter">
                    <h5>
                      {{
                        "pages.createSmartSmsRequest.filters.ertebatat"
                          | translate
                      }}
                    </h5>
                    <div>
                      {{ pageVocabs + "filters.notImplemented" | translate }}
                    </div>
                  </div>
                </div>

                <!-- فرهنگی هنری -->
                <div
                  class="tw-w-full"
                  *ngIf="getMostShowFilterRow('ArtisticCulture')"
                >
                  <div class="disabled-filter">
                    <h5>
                      {{
                        "pages.createSmartSmsRequest.filters.artisticCulture"
                          | translate
                      }}
                    </h5>
                    <div>
                      {{ pageVocabs + "filters.notImplemented" | translate }}
                    </div>
                  </div>
                </div>

                <button
                  type="submit"
                  mat-ripple
                  class="btn tw-w-full tw-mt-5 tw-py-3 btn-hover-rise"
                  [themeColor]="'btn'"
                  (click)="onSubmit()"
                  [disabled]="loading || form.valid == false"
                >
                  <ng-container *ngIf="!loading">
                    {{ "common.submit" | translate }}
                  </ng-container>

                  <!-- loading -->
                  <ng-container *ngIf="loading">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="sr-only">Loading...</span>
                  </ng-container>
                </button>
              </fieldset>
            </div>
            <!-- end of first column -->
          </div>
        </section>

        <section
          class="tw-h-full tw-w-full"
          [class]="!showSidePanel ? '' : 'xl:tw-w-2/3'"
        >
          <fieldset class="tw-h-full">
            <legend class="tw-flex-center">
              <i class="mdi mdi-cog-box mdi-25px tw-ml-2"></i>
              {{ pageVocabs + "legends.requestPublicPlace" | translate }}
            </legend>

            <!-- smart sms operators -->
            <app-smart-sms-operators
              (selectedOperator)="selectedOperator = $event"
              [isShowToggle]="true"
              [isExistsMCI]="true"
              [isExistsIrancell]="true"
              [isExistsRightel]="true"
              (operators)="operators = $event"
            ></app-smart-sms-operators>

            <div class="tw-mb-3 row tw-mt-5">
              <!-- state -->
              <div class="md:tw-w-1/2">
                <zones-select-search
                  #selStates
                  label="common.state"
                  class="tw-w-full"
                  [id]="1"
                  [isDisabled]="!isShowMap"
                  [control]="form?.get('stateControl')"
                  [value]="stateId"
                  (valueChange)="stateId = $event; cityId = -1"
                >
                </zones-select-search>
              </div>
              <!-- end state -->
              <!-- city -->
              <div class="md:tw-w-1/2">
                <zones-select-search
                  #citySelectSearch
                  label="common.city"
                  class="tw-w-full"
                  [id]="stateId"
                  [isDisabled]="!isShowMap"
                  [control]="form?.get('cityControl')"
                  [value]="cityId"
                  (valueChange)="onCityChange($event)"
                >
                </zones-select-search>
              </div>
              <!-- end city -->
            </div>
            <div class="row">
              <div
                class="tw-w-full"
                [ngClass]="{
                  'tw-relative disable-mapboxgl-canvas': !isShowMap
                }"
              >
                @if(!isShowMap){
                <div
                  class="tw-absolute tw-w-full tw-h-full tw-bg-slate-50 dark:tw-bg-slate-800 tw-opacity-40 tw-z-[1] tw-right-0 tw-flex-center"
                ></div>
                <span
                  class="tw-absolute tw-text-gray-500 dark:tw-text-white tw-font-extrabold tw-text-xl text-color tw-top-2/4 tw-left-0 tw-right-0 tw-text-center tw-z-[1]"
                  >{{ "messages.disableMapInSmartSms" | translate }}</span
                >
                }
                <!-- </div> -->
                <smart-send-map-control
                  #Map
                  [Theme]="appStateService.currentThemeMode()"
                  [MultiPolygon]="true"
                  [ShowAddPublicPlace]="true"
                  [ShowAddToPublicPlace]="true"
                  (OnPublicPlaceClick)="onShowAdvanceSearch()"
                  [ShowSaveButton]="false"
                  [manualPolygon]="polygon"
                  [removePreviousPolygon]="removePolygon"
                  [operators]="operators"
                  (expandMap)="isShowSidePanel($event)"
                >
                </smart-send-map-control>
              </div>
            </div>
          </fieldset>
        </section>

        <!-- submit btn -->
        <div class="row tw-flex tw-justify-end tw-items-center tw-px-0">
          <div class="md:tw-w-1/6"></div>
        </div>
      </div>
    </form>
  </div>
</app-page-body>
<!--------------------------------------------------------------- help --------------------------------------------------------------->
<ng-container *ngIf="isVisibleHelpPage">
  <app-help-page
    menuTitle="SendSmartSMS"
    (hidePage)="onHideHelpPage()"
    title="pages.sendSmartSMS.title"
  >
  </app-help-page>
</ng-container>
